import React from "react";
import RewardTimelineItem from "./RewardTimelineItem";

/**
 * Props:
 * rewards (array)
 */
const RewardTimeline = ({ rewards = [] }) => {

  if (!rewards.length) {
    return (
      <p className="text-muted font8">
        No touchpoints history yet.
      </p>
    );
  }

  return (
    <div className="reward-timeline">

      {rewards.map((r, index) => (
        <RewardTimelineItem
          key={index}
          date={r.voucher_date}
          amount={r.total_spending}
          code={r.voucher_code}
          redeemedDate={r.voucher_r_date}
        />
      ))}

    </div>
  );
};

export default RewardTimeline;